/**
 * streamlines add a dynamic value to marginRight.
 * @param {object} param0
 * @param {number|string} param0.$marginRight
 * @returns {string}
 */
const dynMarginRight = ({ $marginRight }) => {
  if ($marginRight === undefined) return "";
  if (typeof $marginRight === "number")
    return `margin-right: ${$marginRight}px;`;
  return `margin-right: ${$marginRight};`;
};

export default dynMarginRight;
